import type * as models from 'pkg/api/models';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { EventFlags, RSVPInterval } from 'pkg/api/models/event';

export enum EventSeriesType {
	Camp = 'camp',
	Cup = 'cup',
	Match = 'match',
	Meeting = 'meeting',
	Practice = 'practice',
	Uncategorized = 'uncategorized',
}

export interface EventSeriesAttachments {
	attachment: models.attachment.Attachment;
	attachmentId: number;
	eventSeriesId: number;
	id: number;
}

export interface EventSeries extends AllowedActionable {
	description: string;
	duration: number;
	events: number[];
	groupId: number;
	id: number;
	location: string;
	rRuleString: string;
	status: string;
	timezone: string;
	title: string;
	type: EventSeriesType;
	userId: number;
	isPrivate: boolean;
	isPublic: boolean;
	hideParticipants: boolean;
	meetBeforeMinutes: number;
	// capacity is the max number of participants. Nil means uncapped.
	capacity?: number | null;
	// rsvpIntervalCount is the number of RSVPInterval to require rsvp before. This is in relation to startsAt.
	rsvpIntervalCount: number;
	// rsvpInterval is the time unit of rsvpIntervalCount
	rsvpInterval: RSVPInterval;
	// inviteIntervalCount is the number of RSVPInterval to send invites before.
	inviteIntervalCount: number;
	// inviteInterval is the time unit of inviteIntervalCount
	inviteInterval: RSVPInterval;
	// reminderIntervalCount is the number of RSVPInterval to send a reminder before.
	reminderIntervalCount: number;
	// reminderInterval is the time unit of reminderIntervalCount
	reminderInterval: RSVPInterval;
	flags: EventFlags[];

	group: models.group.Group;
	user?: models.user.User;
	seriesUsers: models.eventSeriesUser.EventSeriesUser[];
	eventSeriesAttachments: EventSeriesAttachments[];
}
